export const lightTheme = {
  body: "#FCF6F4",
  text: "#000000",
  bodyRgba: "252, 246, 244",
  textRgba: "0,0,0",
  gradientbg:
    " radial-gradient(circle, rgba(255,255,255,1) 0%, rgba(249,248,247,1) 21%, rgba(251,245,255,1) 46%, rgba(255,245,247,1) 69%, rgba(252,246,244,1) 89%);"
};

export const darkTheme = {
  body: "#000000",
  text: "#FCF6F4",
  bodyRgba: "0,0,0",
  textRgba: "252, 246, 244",
  gradientbg:
    " radial-gradient(circle, rgba(18,23,26,1) 0%, rgba(15,20,22,1) 32%, rgba(9,12,13,1) 69%, rgba(3,4,4,1) 100%);"
};
